export default {
  feedback: {
    login_success: 'Accesso effettuato',
    logout_success: 'Disconnessione effettuata',
  },
};
